import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);
const storage = typeof window !== 'undefined' ? window.sessionStorage : null;

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = storage?.getItem('admin_token');
    const adminInfo = storage?.getItem('admin_info');

    if (token && adminInfo) {
      try {
        setAdmin(JSON.parse(adminInfo));
      } catch (e) {
        storage?.removeItem('admin_token');
        storage?.removeItem('admin_info');
      }
    }
    setLoading(false);
  }, []);

  const login = (token, adminInfo) => {
    storage?.setItem('admin_token', token);
    storage?.setItem('admin_info', JSON.stringify(adminInfo));
    setAdmin(adminInfo);
  };

  const logout = () => {
    storage?.removeItem('admin_token');
    storage?.removeItem('admin_info');
    setAdmin(null);
  };

  const isAuthenticated = !!admin;

  return (
    <AuthContext.Provider value={{ admin, login, logout, isAuthenticated, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
